module.exports = __webpack_public_path__ + "static/media/black.22c1967d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/space-gray-aluminum-case/black.jpeg
// module id = 2085
// module chunks = 0